export const getIsReactSnap = (): boolean => {
  return navigator.userAgent === "ReactSnap";
};
